import { Map as IMap } from 'immutable';

import {
    productClickedSegmentData,
    buyGiftCardButtonClickedSegmentData,
    categoryDropdownCloseSegmentData
} from '../segment/segmentSelectors';


export const SAVE_SELECTED_CARD = '@@storefront/SAVE_SELECTED_CARD';
export const RESET_CARD_SELECTION = '@@storefront/RESET_CARD_SELECTION';
export const REQUEST_FACEPLATE_GROUPS = '@@storefront/REQUEST_FACEPLATE_GROUPS';
export const SET_FACEPLATE_GROUPS = '@@storefront/SET_FACEPLATE_GROUPS';
export const FACEPLATE_PREFETCH_IMAGES = '@@storefront/FACEPLATE_PREFETCH_IMAGES';
export const FACEPLATE_PREFETCH_END = '@@storefront/FACEPLATE_PREFETCH_END';
export const CATEGORY_DROPDOWN_SELECTION = '@@storefront/CATEGORY_DROPDOWN_SELECTION';
export const SELECTED_CARD_TYPE = '@@storefront/SELECTED_CARD_TYPE';
export const CLICKED_ON_UYO = '@@storefront/CLICKED_ON_UYO';
export const RESET_FACEPLATE_INFO = '@@storefront/RESET_FACEPLATE_INFO';

const initialState = IMap({});


const faceplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_SELECTED_CARD: {
            
            let { faceplate, isPlastic } = action;
            faceplate = faceplate.set('category', action.category);
            let newState = state.set('selectedFaceplate', faceplate);
            if (isPlastic) {
                newState = newState.set('physicalFaceplateCategory', action.category);
            } else {
                newState = newState.set('digitalFaceplateCategory', action.category);
            }
            return newState;
        }
        case SET_FACEPLATE_GROUPS: {
            return state.set('faceplateGroups', action.faceplateGroups);
        }
        case RESET_CARD_SELECTION:
            return state.delete('selectedFaceplate');
        case SELECTED_CARD_TYPE: {
            const { cardType, buyNowDigitalAfterCardLimit = false } = action;
            return state
                .set('selectedCardType', cardType)
                .set('buyNowDigitalAfterCardLimit', buyNowDigitalAfterCardLimit);
        }
        case CLICKED_ON_UYO: {
            return state.set('clickedOnUYO', action.clickedOnUYO);
        }
        case RESET_FACEPLATE_INFO: {
            const selectedCardType = state.get('selectedCardType');
            return initialState.set('selectedCardType', selectedCardType);
        }
        default:
    }
    return state;
};


export const saveSelectedCard = (category, faceplate, includeSegment = true, isPlastic = false) => ({
    type: SAVE_SELECTED_CARD,
    category,
    faceplate,
    isPlastic,
    meta: {
        ...(includeSegment && {
            segment: {
                eventAction: 'Product Clicked',
                eventData: productClickedSegmentData(faceplate, category)
            }
        })
    }

});

export const saveSelectedCardOnBuyButtonClick = (category,
    faceplate,
    submitButtonTitleName,
    isPhysicalCardType) => ({
    type: SAVE_SELECTED_CARD,
    category,
    faceplate,
    isPlastic: isPhysicalCardType,
    meta: {
        segment: {
            eventAction: 'Buy Gift Card',
            eventData: buyGiftCardButtonClickedSegmentData(faceplate,
                category,
                submitButtonTitleName,
                isPhysicalCardType)
        }
    }
});

export const categoryDropdownSelectClick = (
    categoryDropdownClickData,
    eventAction = 'Category dropdown'
) => ({
    type: CATEGORY_DROPDOWN_SELECTION,
    categoryDropdownClickData,
    meta: {
        segment: {
            eventAction,
            eventData: categoryDropdownCloseSegmentData(categoryDropdownClickData)
        }
    }
});

export const resetCardSelection = () => ({
    type: RESET_CARD_SELECTION
});

export const requestFaceplateGroups = params => ({
    type: REQUEST_FACEPLATE_GROUPS,
    params
});

export const setFaceplateGroups = faceplateGroups => ({
    type: SET_FACEPLATE_GROUPS,
    faceplateGroups
});

export const setClickedOnUYO = clickedOnUYO => ({
    type: CLICKED_ON_UYO,
    clickedOnUYO
});

export const faceplatePrefetchImages = faceplates => ({
    type: FACEPLATE_PREFETCH_IMAGES,
    faceplates
});

export const selectedCardType = (cardType, buyNowDigitalAfterCardLimit = false) => ({
    type: SELECTED_CARD_TYPE,
    cardType,
    buyNowDigitalAfterCardLimit
});

export default faceplateReducer;
